import ProjectAccessStandardSettings from "./standard-access"
import ProjectAccessLimitedSettings from "./limited-access"
import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings"
import ProjectAccessReadonlySettings from "./readonly-access"

const fieldsConfig = {
    standard                    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : ProjectAccessStandardSettings
    },
    limited                     : {
        type            : ServerSettingsFieldType.CLASS,
        class           : ProjectAccessLimitedSettings
    },
    readonly                    : {
        type            : ServerSettingsFieldType.CLASS,
        class           : ProjectAccessReadonlySettings
    },
    showParentsDespiteAccess    : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : false // I think it's better to show parents by default or no ??? fck... I dunno - it depends on company
    }
}

export default class ProjectAccessSettings extends ServerSettings {

    public standard                 : ProjectAccessStandardSettings
    public limited                  : ProjectAccessLimitedSettings
    public readonly                 : ProjectAccessReadonlySettings

    public showParentsDespiteAccess : boolean

    constructor(config:any) {
        super(config, fieldsConfig)

        this.standard                   = this.initValue('standard')
        this.limited                    = this.initValue('limited')
        this.readonly                   = this.initValue('readonly')

        this.showParentsDespiteAccess   = this.initValue('showParentsDespiteAccess')
    }

    toJSON() {
        const result = {}

        this.valueToJson(result, 'standard')
        this.valueToJson(result, 'limited')
        this.valueToJson(result, 'readonly')
        this.valueToJson(result, 'showParentsDespiteAccess')

        return result
    }
}